import { Component, inject } from '@angular/core';
import { SharedService } from '../../../core/Services/shared';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-footer',
  imports: [TranslateModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent {
flag: boolean=false;
shared = inject(SharedService);
currentYear: number = new Date().getFullYear();
constructor(    public router: Router,
         public location: Location,

 ) {


}
gotoCourts(){
      this.router.navigate(['/'], { fragment: 'branchs' });
             this.location.replaceState('');


}
ngAfterViewInit(): void {
  setTimeout(() => {
      this.flag = this.shared.checkLoaded();
  }, 1000);

}
}
